import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import APModal from 'components/Modal/APModal';
import './styles.scss';

const LeadSettingModal = ({ open, onClose, title, children }) => {
  return (
    <APModal
      open={open}
      title={title}
      name="lead-setting"
      className={clsx('lead-setting-modal__container')}
      onClose={onClose}
      actions={(
        <button className="button"
          onClick={onClose}
        >
          All set
        </button>
      )}
    >
      {children}
    </APModal>
  );
};

LeadSettingModal.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
  children: PropTypes.node,
};

LeadSettingModal.defaultProps = {};

export default LeadSettingModal;
